import { TemplateAddress, ItemAddress, Coordinates, MapItem } from './types';

export const getCoordinates = (addr?: TemplateAddress): Coordinates | null => {
  if (!addr) return null;
  if (addr.latitude !== undefined && addr.longitude !== undefined) {
    return { lat: Number(addr.latitude), lng: Number(addr.longitude) };
  }
  if (addr.location?.latitude !== undefined && addr.location?.longitude !== undefined) {
    return { lat: Number(addr.location.latitude), lng: Number(addr.location.longitude) };
  }
  return null;
};

export const getItemCoordinates = (item: MapItem): Coordinates | null => {
  const addr = item.loading_address as any;
  if (!addr) return null;

  if (addr.location?.latitude !== undefined && addr.location?.longitude !== undefined) {
    const lat = Number(addr.location.latitude);
    const lng = Number(addr.location.longitude);
    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
      return { lat, lng };
    }
  }
  if (addr.latitude !== undefined && addr.longitude !== undefined) {
    const lat = Number(addr.latitude);
    const lng = Number(addr.longitude);
    if (!isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0) {
      return { lat, lng };
    }
  }
  return null;
};

export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}.${month}`;
  } catch {
    return '';
  }
};

export const formatDateForInput = (isoDate?: string): string => {
  if (!isoDate) return '';
  try {
    return new Date(isoDate).toISOString().split('T')[0];
  } catch {
    return '';
  }
};

export const formatLocation = (addr?: ItemAddress): string => {
  if (!addr) return '—';
  const parts: string[] = [];
  if (addr.country_code) parts.push(addr.country_code);
  if (addr.post_code) parts.push(addr.post_code);
  const city = addr.city || addr.country || addr.full_address?.split(',')[0];
  if (city) parts.push(city);
  return parts.length > 0 ? parts.join(' ') : '—';
};

export const getTodayDate = (): string => {
  return new Date().toISOString().split('T')[0];
};
